var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.checkCppVersion = checkCppVersion;
exports.matchVersion = matchVersion;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _jsVersion = require("./jsVersion");
function checkCppVersion() {
    var cppVersion = global._REANIMATED_VERSION_CPP;
    if (cppVersion === undefined) {
        throw new Error("[Reanimated] Couldn't determine the version of the native part of Reanimated.\nSee `https://docs.swmansion.com/react-native-reanimated/docs/guides/troubleshooting#couldnt-determine-the-version-of-the-native-part-of-reanimated` for more details.");
    }
    var ok = matchVersion(_jsVersion.jsVersion, cppVersion);
    if (!ok) {
        throw new Error("[Reanimated] Mismatch between JavaScript part and native part of Reanimated (".concat(_jsVersion.jsVersion, " vs ").concat(cppVersion, ").\nSee `https://docs.swmansion.com/react-native-reanimated/docs/guides/troubleshooting#mismatch-between-javascript-part-and-native-part-of-reanimated` for more details."));
    }
}
function matchVersion(version1, version2) {
    if (version1.match(/^\d+\.\d+\.\d+$/) && version2.match(/^\d+\.\d+\.\d+$/)) {
        var _version1$split = version1.split("."), _version1$split2 = (0, _slicedToArray2.default)(_version1$split, 2), major1 = _version1$split2[0], minor1 = _version1$split2[1];
        var _version2$split = version2.split("."), _version2$split2 = (0, _slicedToArray2.default)(_version2$split, 2), major2 = _version2$split2[0], minor2 = _version2$split2[1];
        return major1 === major2 && minor1 === minor2;
    } else {
        return version1 === version2;
    }
}
